"use client";

import styles from "./AuthorizeEmailInput.module.scss";

import {
  setFieldError,
  setFieldValue } from "@/stores";

import { useForm } from "@/hooks";
import {
  Fieldset,
  Input,
} from "@vetty/ui";

/**
 * AuthorizeEmailInput Component
 *
 * Email input field for authorize form with validation and error handling.
 * Manages email field state and clears errors on user input.
 */
export const AuthorizeEmailInput = () => {
  // Get form errors from global state
  const { errors } = useForm();

  /**
   * Handles email input changes
   * Updates field value and clears any existing errors
   */
  const handleInputChange = (field: string, value: string) => {
    setFieldValue(field, value);
    setFieldError(field, "");
  };

  return (
    <Fieldset
      className={styles["comp"]}
      isError={errors.email}
      errorMessage={errors.email}
    >
      <Input
        id={"email"}
        label={"E-mail"}
        onChange={(v) => handleInputChange("email", v)}
      />
    </Fieldset>
  );
};
